import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Teams from './pages/Teams';
import Players from './pages/Players';
import Fixtures from './pages/Fixtures';
import Rules from './pages/Rules';
import Register from './pages/Register';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import useDataLoader from './hooks/useDataLoader';
import RegistrationStatus from './components/RegistrationStatus';
import Auction from './pages/Auction';
import AuctionResults from './pages/AuctionResults';
import AuctionAdmin from './pages/AuctionAdmin';
import AuctionPool from './pages/AuctionPool';

const RegisterAccessControl = ({ currentSeason }) => {
  const now = new Date();
  const parseDate = (value) => (value ? new Date(value) : null);

  // Show nothing while season is still loading — prevents flash of a message
  if (!currentSeason) return null;

  const registrationStart = parseDate(currentSeason?.registration_start_date);
  const registrationEnd = parseDate(currentSeason?.registration_end_date);

  // State 1 — registration hasn't opened yet
  if (registrationStart && now < registrationStart) {
    return <RegistrationStatus mode="soon" openDate={registrationStart} />;
  }

  // State 2 — registration is open
  const registrationOpen = registrationStart
    ? registrationEnd
      ? now >= registrationStart && now <= registrationEnd
      : now >= registrationStart
    : false;

  if (registrationOpen) {
    return <Register />;
  }

  // State 3 — registration has closed
  return <RegistrationStatus mode="closed" />;
};

function App() {
  // Load initial data on app startup
  const { currentSeason } = useDataLoader();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/auction/admin" element={<AuctionAdmin />} />
        <Route path="/auction" element={<Auction />} />
        <Route path="/auction/pool" element={<AuctionPool />} />
        <Route path="/auction/results" element={<AuctionResults />} />
        <Route path="/" element={<Home />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/players" element={<Players />} />
        <Route path="/fixtures" element={<Fixtures />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/register" element={<RegisterAccessControl currentSeason={currentSeason} />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </>
  );
}

export default App;